export default {
  candidateDocuments: [],
  candidateDocument: undefined,
};
